"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerSize = exports.classes = void 0;
var classes = {
  loader: 'bds-loader',
  loaderContainer: 'bds-loader-container',
  loaderOverlay: 'bds-loader-overlay',
  loaderOverlayOnContainer: 'bds-loader-overlay-on-container',
  smallLoader: 'bds-loader-small',
  mediumLoader: 'bds-loader-medium',
  largeLoader: 'bds-loader-large'
};
exports.classes = classes;
var spinnerSize = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.spinnerSize = spinnerSize;